import React, { useState } from "react";
import { CgChevronRight } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import { Link } from "react-router-dom";
import Sportsbook from "../../Sportsbook";
import "./mobileProfile.css";
import FooterAppButton from "../../../components/BettDraftAppButton/FooterAppButton";
const MobileProfile = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { auth, cart } = state;
  let verification = state?.auth?.user?.verification;
  const wallet_access = state?.auth?.geoWallet;
  const ProfileMenus = [
    {
      name: "Personal Information",
      path: "personal-information",
    },
    {
      name: "Change Email",
      path: "change-email",
    },
    {
      name: "Change Password",
      path: "change-password",
    },
    {
      name: "Responsible Gaming",
      path: "responsible-gaming-settings",
    },
    {
      name: "My Entries",
      path: "my-entries",
    },
    {
      name: "Wallet",
      path: verification == "1" ? (wallet_access ? "userwallet" : "") : "",
    },
    //commeted protmotions for now as not offering any marketing promotions
    // {
    //   name: "Promotions",
    //   path: "promotions",
    // },
    // {
    //   name: "My Corepay",
    //   path: "mycorepay",
    // },
    {
      name: "Contact US",
      path: "contact-us",
    },
    {
      name: "Refer A Friend",
      path: "refer-friend",
    },
    {
      name: "Promo Code",
      path: "promo-code",
    },
    {
      name: "Logout",
     onClick: () => {
        dispatch({
          type: Actions.LOGOUT,
        });
        dispatch({
          type: Actions.REMOVE_ALL_BETSLIP,
        });
        dispatch({
          type: Actions.PARLAY_BETS,
          data: false,
        }); 
        sessionStorage.clear();
        navigate("/login");
      }
    }
  ];

  return (
    <div id="Sportbook">
      <div className="container-fluid bg-color-sportbook">
        <div className="inner-space1">
          <div
            className="custom-fff-div2"
            style={{ marginTop: "-68px", background: "#E4E4E4!important" }}
          >
            <div className="flex-column-hidden">
              <div style={{ padding: "9px" }}>
                <h5 style={{ color: "#0D3862", fontWeight: "bold" }}>
                  {"Profile"}
                </h5>
              </div>
              {ProfileMenus.map((item, index) => {
                if(state?.auth?.user?.player_type == "6" && item.name == "Refer A Friend"){
                  return null;
                 }
                return item?.onClick ? (
                  <div
                    key={index}
                    className="sideBar-game"
                    onClick={item.onClick}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="linkdiv-box">
                      <div className="flex-start-colum">
                        <a
                          className="link-according profilecolor"
                          style={{ color: "#0D3862!important" }}
                        >
                          <span
                            style={{
                              color: "red!important",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.name}
                          </span>
                          <CgChevronRight />
                        </a>
                        <div className="link-according-border"></div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Link
                    key={index}
                    to={`/${item.path}`}
                    className="sideBar-game"
                    onClick={() => {
                      dispatch({
                        type: Actions.TEST_CASE,
                        data: false,
                      });
                    }}
                  >
                    <div className="linkdiv-box">
                      <div className="flex-start-colum">
                        <a
                          className="link-according profilecolor"
                          style={{ color: "#0D3862!important" }}
                        >
                          <span
                            style={{
                              color: "red!important",
                              fontWeight: "bold",
                              fontSize: "14px",
                            }}
                          >
                            {item.name}
                          </span>
                          <CgChevronRight />
                        </a>
                        <div className="link-according-border"></div>
                      </div>
                    </div>
                  </Link>
                );
              })}
           
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileProfile;
